import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { AnimatePresence, motion } from 'framer-motion';
import { userAtom, mainPageInitializeAtom } from '../../../atoms/Atoms';
import AuthenticatedSideBar from '../menu-sidebar/shared-components/AuthenticatedSideBar';
import { Spinner } from '../Spinner';
import { backdropVariants } from '../../../utils';

function MainPage({ children }) {
  const user = useRecoilValue(userAtom);
  const [initializing, setInitializing] = useRecoilState(mainPageInitializeAtom);

  useEffect(() => {
    setTimeout(() => setInitializing(false), 250);
  }, []);

  useEffect(() => {
    if (!initializing) {
      if (user?.forcePasswordReset) {
        window.location = '/updatepass';
      } else if (!user) {
        window.location = '/';
      }
    }
  }, [initializing]);

  return (
    <AnimatePresence>
      <div key="content" className="flex w-full flex-1">
        {/* The <aside> stretches to the full height of the row so the rail's
            border and background run the length of the page, while the inner
            panel sticks below the header as the page scrolls. */}
        <aside className="hidden w-64 shrink-0 border-r border-line bg-sidebar md:block">
          <div className="sticky top-16 max-h-[calc(100vh-4rem)] overflow-y-auto">
            <AuthenticatedSideBar />
          </div>
        </aside>
        <main className="min-w-0 flex-1 px-4 py-6 md:px-6">
          {children}
        </main>
      </div>
      <motion.div
        key="init-overlay"
        variants={backdropVariants}
        initial="visible"
        animate="hidden"
        exit="visible"
        className={`${initializing ? 'fixed' : 'hidden'} bg-gray-800 inset-0 bg-opacity-75 z-20`}
      >
        <div className="loading-screen loading-screen-full-white">
          <Spinner className="text-accentColor" big />
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default MainPage;
